import { Brand } from '@emico/schema-org'

const BrandSchemaOrg = () => <Brand />

export default BrandSchemaOrg
